import { useContext } from 'react';
import { aiAssistantContext } from '../../../../state/AIAssistantContextProvider';
import { ActiveView } from '../constants';
import useScreenSize from '../../../../utils/useScreenSize';

const useIsPodcastLoadingViewActive = (): boolean => {
  const { activeView, isPodcastV1UxEnabled } = useContext(aiAssistantContext);
  const { isXsScreen, isSmScreen } = useScreenSize();
  const isXsOrSmScreen = isXsScreen || isSmScreen;

  return isPodcastV1UxEnabled && !isXsOrSmScreen && activeView === ActiveView.PODCAST_LOADING;
};

export default useIsPodcastLoadingViewActive;
